import { FilterList } from '@/common/entities/filter/FilterList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityTabs } from '@/common/entityFramework/entityTabs/EntityTabs';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { ValList } from '@/common/val/ValList';
import { useCtrtOutline } from '@/md/entities/ctrt/useCtrtOutline';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { PriceResList } from '../priceRes/PriceResList';
import { ProgProdCardList } from '../progProd/ProgProdCardList';
import { ProgBrandBonaFidePctList } from './ProgBrandBonaFidePctList';
import { ProgContextStrip } from './ProgContextStrip';
import { ProgForm } from './ProgForm';

// The Program is the unit of work when building a Contract: this page keeps the Program form and all of its
// Products (with their Tiers) in one place, so nothing below the Program requires navigating away
export const ProgDetail = () => {
  const { entityObj, entityFormMode } = useEntityMgr();

  const isAdd = entityFormMode === EntityFormMode.ADD;
  const canEdit = entityObj.status === 'DRAFT';

  const { augButtons, outlineContent } = useCtrtOutline({
    ctrtId: entityObj.ctrtId,
    entity: 'PROG',
    entityId: entityObj.id,
  });

  const workspace = (
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
      <Stack spacing={3} sx={{ pb: 2 }}>
        <ProgForm />
        {isAdd ?
          <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
            <Typography color="text.secondary">Save the program to add products.</Typography>
          </Paper>
        : <ProgProdCardList progObj={entityObj} canEdit={canEdit} />}
      </Stack>
    </Box>
  );

  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: workspace }];

  if (entityObj.status === 'IMPL') {
    tabSpecs.push({
      id: 'priceRes',
      label: entityObj.progType === 'PRICE' ? 'Price Results' : 'Rebate Results',
      content: <PriceResList progId={entityObj.id} />,
    });
  }

  tabSpecs.push(
    { id: 'bonaSplit', label: 'Bona Fide Brand Splits', content: <ProgBrandBonaFidePctList progObj={entityObj} /> },
    {
      id: 'filter',
      label: 'Program Filters',
      content: <FilterList parentEntity="PROG" parentEntityObj={entityObj} />,
    },
    { id: 'val', label: 'Validations', content: <ValList parentEntity="PROG" parentEntityId={entityObj.id} /> },
  );

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons}>
      {outlineContent ?? (
        <>
          <ProgContextStrip ctrtId={entityObj.ctrtId} />
          <EntityTabs tabSpecs={tabSpecs} />
        </>
      )}
    </EntityDetail>
  );
};
